export default __webpack_public_path__ + "static/media/15.a30c2397.jpg";